import dynamic from "next/dynamic";
const LoginPage = dynamic(() => import("@/components/page-auth/Login"), { ssr: false });

export default LoginPage;

export const getServerSideProps = async () => ({
  props: { noHeader: true },
});
